import slugify from "slugify";

// Note that this code should be moved to bsp sdk
export const escapeFile = (file: File) => {
  // Recreate the same file with escaped name
  return new File([file], escapeFilename(file.name), { type: file.type });
};

const escapeFilename = (filename: string) => {
  return slugify(filename, { remove: /[\(\)\+"<>#%\{\}\|\\\^~\[\]`;\?:@=&]/g });
};
